import { InsType } from 'constants/enums/insType.enum';
import React, { useEffect, useState } from 'react';
import { IProps } from './types';
import commonService from 'utils/commonService';
import { useSelector } from 'react-redux';
import { RootReducersState } from 'redux/reducers';
import { SysOptType } from 'constants/enums/sysOptType.enum';
import apiService from 'bff/services/apiService';
import { BaseRes } from 'bff/models/base/baseRes';
import { SysOptions } from 'bff/models/info/sysoptions';

const PolicyInfo: React.FC<IProps> = (props) => {
  const resources = useSelector((state: RootReducersState) => state.resources);
  const [certEnUrl, setCertEnUrl] = useState<string>();

  /**
   * @description 取得英文投保證明連結
   */
  useEffect(() => {
    (async () => {
      const sysOptionBaseReq = commonService.getApiReqData({ PCLASS: [SysOptType.WWUOWS] });
      const reqConfig = commonService.getReqConfig();
      const response: BaseRes<SysOptions> = await apiService.fetchSysOptions(sysOptionBaseReq, reqConfig);
      if (response && response.TRANRS && response.TRANRS.WWUOWS) {
        const item = response.TRANRS.WWUOWS.find(it => it.PARAM_ID === 'CERT_EN_URL');
        if (item) setCertEnUrl(item.PARAM_VALUE);
      }
    })();
  }, []);

  return (
    <div className="policy-info">
      <div className="policy-info__container">
        <div className="element__list-group">
          <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Insurance_type')}</div>
          <div className="element__list-group-content">{props.BC_TYPE}</div>
        </div>
        <div className="element__list-group">
          <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Order_number')}</div>
          <div className="element__list-group-content">{props.APPLY_NO}</div>
        </div>
        <div className="element__list-group">
          <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Policy_status_radio')}</div>
          <div className="element__list-group-content">{props.POLICY_STATUS}</div>
        </div>
        <div className="element__list-group">
          <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Promo_code')}</div>
          <div className="element__list-group-content">
            {props.PROGRAM_ID ? props.PROGRAM_ID : ''}
          </div>
        </div>
        {
          props.INS_TYPE_ID !== InsType.Travel && (
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Delivery_time')}</div>
              <div className="element__list-group-content">
                {props.APPLY_TIME ? props.APPLY_TIME : '-'}
              </div>
            </div>
          )
        }
        <div className="element__list-group">
          <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Policy_number')}</div>
          <div className="element__list-group-content">
            {props.POLICY_NO ? props.POLICY_NO : '-'}
          </div>
        </div>
        <div className="element__list-group">
          <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Payment_status')}</div>
          <div className="element__list-group-content">{props.PAYMENT_STATUS}</div>
        </div>
        <div className="element__list-group">
          <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Policy_form')}</div>
          <div className="element__list-group-content">{props.POLICY_DELIVERY}</div>
        </div>
        {props.INS_TYPE_ID === InsType.Travel ? (
          <div className="element__list-group">
            <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_English_insurance_cert_dl')}</div>
            <div className="element__list-group-content">{(props.IS_CERTEN === 'Y' && certEnUrl)
              ? (
                <a
                  href="/#"
                  className="element__link"
                  onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                    e.stopPropagation();
                    e.preventDefault();
                    if (certEnUrl) window.open(certEnUrl, '_blank');
                  }}
                >
                  請點擊下載
                </a>
              ) : (
                <>-</>
              )}
            </div>
          </div>
        ) : null}

      </div>
    </div>
  );
};

export default PolicyInfo;
